var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 37,
    viewBox: "0 0 40 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 38,
    height: 35,
    rx: 4,
    fill: "#FFBF33",
    stroke: "#FFBF33",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2378_8257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4166 17.0424C26.9097 17.0424 26.5 17.4531 26.5 17.959V25.2924C26.5 25.7974 26.0893 26.209 25.5834 26.209H12.75C12.2439 26.209 11.8334 25.7974 11.8334 25.2924V12.459C11.8334 11.9539 12.2439 11.5424 12.75 11.5424H20.0834C20.5903 11.5424 21 11.1317 21 10.6258C21 10.1197 20.5903 9.70898 20.0834 9.70898H12.75C11.2338 9.70898 10 10.9428 10 12.459V25.2924C10 26.8085 11.2338 28.0424 12.75 28.0424H25.5834C27.0995 28.0424 28.3334 26.8085 28.3334 25.2924V17.959C28.3334 17.4521 27.9235 17.0424 27.4166 17.0424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.595 16.2072C18.5309 16.2714 18.4878 16.3529 18.4695 16.4409L17.8214 19.6823C17.7912 19.8326 17.8389 19.9875 17.947 20.0966C18.0341 20.1837 18.1514 20.2304 18.2716 20.2304C18.3008 20.2304 18.3312 20.2277 18.3614 20.2213L21.6018 19.5732C21.6916 19.5548 21.7732 19.5118 21.8365 19.4475L29.0891 12.1949L25.8487 8.95459L18.595 16.2072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3293 6.71331C30.4357 5.81952 28.9818 5.81952 28.0889 6.71331L26.8203 7.98189L30.0608 11.2223L31.3293 9.95359C31.7621 9.52188 32.0004 8.94617 32.0004 8.33387C32.0004 7.72156 31.7621 7.14585 31.3293 6.71331Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2378_8257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(10 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.0947f53db1c2e2ed89da01dbefbe1d41.svg";
export { ForwardRef as ReactComponent };